export default __webpack_public_path__ + "static/media/subadmin.505a64d1.svg";